<template>
  <div>
    <template v-for="(item, ind) in modelData">
      <component
        v-bind:is="item.model_name"
        :key="ind"
        :itemData="item">
      </component>
    </template>
    <fo-footer></fo-footer>
  </div>
</template>

<script>
import banner from './Models/banner.vue'
import about from './Models/about.vue'
import practice from './Models/practice.vue'
import team from './Models/team.vue'
import cases from './Models/cases.vue'
import loglink from './Models/loglink.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    banner,
    about,
    practice,
    team,
    cases,
    loglink
  },
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      modelData: [
        {
          title: '轮播图',
          sub_title: '轮播图',
          model_name: 'banner',
          visible: true
        }, {
          title: '融英律师事务所',
          sub_title: '山川融合 聚华含英',
          model_name: 'about',
          visible: true
        }, {
          title: '业务范围',
          sub_title: '我们能为您排忧解难',
          model_name: 'practice',
          visible: true
        }, {
          title: '荣誉团队',
          sub_title: '荣誉律师事务所的精英',
          model_name: 'team',
          visible: true
        }, {
          title: '案例',
          sub_title: '我们致力于维护客户权益',
          model_name: 'cases',
          visible: true
        }, {
          title: '其他链接',
          sub_title: '其他链接',
          model_name: 'loglink',
          visible: true
        }
      ]
    }
  },
  watch: {
    'commonData.web_pages' (obj) {
      const page = JSON.parse(obj.value).filter(item => item.value === this.$route.path)
      if (page.length) {
        this.modelData = page[0].children.filter(model => model.visible)
      }
    }
  },
  mounted () {
    if (this.commonData.web_comp_intro.value) {
      const page = JSON.parse(this.commonData.web_pages.value).filter(item => item.value === this.$route.path)
      if (page.length) {
        this.modelData = page[0].children.filter(model => model.visible)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue